import React from "react";
import {
  EditOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import GoogleLogo from "../../../assets/images/auth/gmail.svg";
import OutlookLogo from "../../../assets/images/auth/microsoft.png";

export const audienceSourceOptions = [
  {
    id: "csv",
    title: "Import CSV",
    description: "Upload Contacts using .CSV file",
    icon: <UploadOutlined />,
    iconClass: "tw-bg-secondary-color tw-text-theme",
  },
  {
    id: "manual",
    title: "Add Manually",
    description: "Type or paste contacts in grid",
    icon: <EditOutlined />,
    iconClass: "tw-bg-secondary-color tw-text-theme",
  },
  {
    id: "google",
    title: "Google Contacts",
    description: "Sync from your google accounts",
    icon: <img src={GoogleLogo} alt="Google" className="tw-w-5 tw-h-5" />,
    iconClass: "",
  },
  {
    id: "outlook",
    title: "Outlook contacts",
    description: "Sync from Microsoft 365",
    icon: <img src={OutlookLogo} alt="Outlook" className="tw-w-5 tw-h-5" />,
    iconClass: "",
  },
];

export const audienceSteps = [
  { number: 1, label: "SOURCE" },
  { number: 2, label: "PREPARE" },
  { number: 3, label: "REVIEW & SAVE" },
];
